// extracted by mini-css-extract-plugin
module.exports = {"input":"simple-search-bar_input__l08Px"};